import { render } from "./LogoImg.vue?vue&type=template&id=5a05f80e&scoped=true&ts=true"
import script from "./LogoImg.vue?vue&type=script&lang=ts"
export * from "./LogoImg.vue?vue&type=script&lang=ts"

import "./LogoImg.vue?vue&type=style&index=0&id=5a05f80e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a05f80e"]])

export default __exports__